import { useEffect } from "react";
import { useLocation, useSearch } from "wouter";
import { useTenantTheme } from "@/hooks/useTenantTheme";

export default function SelfServicePortal() {
  useTenantTheme();
  const [, setLocation] = useLocation();
  const search = useSearch();

  useEffect(() => {
    const target = search ? `/my-courses?${search}` : "/my-courses";
    setLocation(target, { replace: true });
  }, [search, setLocation]);

  return null;
}
